import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";

function HeroSection() {
  const videoRef = useRef(null);
  const sectionRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.playbackRate = 1;
    video.defaultMuted = true;
    video.muted = true;
    setIsMuted(true);
    video.play().catch(() => {
      // The canPlay handler retries once the browser has loaded enough media.
    });
  }, []);

  const playVideo = () => {
    const video = videoRef.current;
    if (!video) return;

    video.play().catch(() => {});
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting && videoRef.current) {
          videoRef.current.muted = true;
          setIsMuted(true);
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(videoRef.current.muted);
    }
  };

  return (
    <div>
      <section className="hero-section" ref={sectionRef}>
        {/* Background Video */}
        <video
          ref={videoRef}
          className="hero-bg-video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          onCanPlay={playVideo}
        >
          <source src="assets/video/paraclearth_intro_video.mp4" type="video/mp4" />
        </video>

        {/* Mute Toggle */}
        <button className="hero-mute-btn" onClick={toggleMute} aria-label={isMuted ? "Unmute" : "Mute"}>
          <i className={`ti ${isMuted ? "ti-volume-off" : "ti-volume"}`}></i>
        </button>
        <div className="divider"></div>

        {/* Left Side Text */}
        <div
          className="left-side-text wow fadeIn"
          data-wow-duration="1000ms"
          data-wow-delay="1200ms"
        ></div>

        <div className="container">
          <div className="row">
            <div className="col-12 col-md-9 col-lg-7 col-xxl-6">
              {/* Hero Content */}
              <div className="hero-content">
<h2
                  className="mb-4 wow fadeInUp text-white"
                  data-wow-duration="1000ms"
                  data-wow-delay="400ms"
                >
                  A New Dawn in Law Practice
                </h2>
<p
                  className="text-white wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="600ms"
                >
                  Paraclete and Earth Increase LP (Paraclearth) is a full-service commercial law firm providing bespoke legal, transactional, and governance advisory to a growing portfolio of local and international clients.
                </p> 
                <div className="d-flex flex-wrap align-items-center gap-4">
                  {/* Button */}
                  
                <Link to="/bookconsultation" className="btn btn-primary wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="800ms">
                  <span>
                    Book Consultation <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    Book Consultation <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>


                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default HeroSection;
